<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="mainFiltersArea" [ngClass]="{'mainFiltersArea-disabled': !filtersLoaded, 'mobile': isHandset}">
  <h6 class="filter-label">
    {{ filtersLoaded ? 'Filters' : 'Loading filters...' }}
    <div class="loader-filters">
      <div *ngIf="!filtersLoaded" class="loader-filters-inner ball-grid-pulse">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </h6>
  <!-- <div class="collapseOptions">
    <span (click)="expandAllFilters()">+ Expand All</span> &nbsp; <span style="font-weight: bold;">|</span>
    &nbsp;<span (click)="collapseAllFilters()">&ndash; Collapse All</span>
  </div> -->
  <div *ngIf="filtersLoaded" style="display: contents;">
    
    <div class="filterSection"
      [ngClass]="{'opened': filterExpandToggles['yearsopen'], 'closed': !filterExpandToggles['yearsopen']}">
      <h6 (click)="collapseAllFilters('yearsopen'); filterExpandToggles['yearsopen'] ? openDateFilter() : null">
        <span class="selectedCount" [hidden]="!activeDateFilters || activeDateFilters.length < 1">
          ({{ activeDateFilters.length }} selected)
          </span>
        Dates
      </h6>
      <div class="innerFilterOptions">
        <button class="btn btn-link" style="padding: 0;" (click)="openDateFilter()">
          {{ activeDateFilters.length > 0 ? 'Edit' : 'Select' }} Date Filters...
        </button>
        <app-date-filter *ngIf="showDateFilter" [datesData]="datesFilterData" [showQuarters]="imageTypeFilter.uid === 2" [dropdownTypeDebounceTime]="appGlobalsSvc.dropdownTypeDebounceTime"
          (filtersSet)="translateDateToFilter()" [(activeDateFilters)]="activeDateFilters"
          (closePressed)="closeFilterBoxes()"></app-date-filter>
        <div *ngFor="let d of activeDateFilters">
          <i class="fal fa-check-square"></i>
          {{ d.year == 0 ? ' ? ' : (d.year || '*') }}
          {{ d.month ? shortMonths[d.month].txt : '*' }}
          <span *ngIf="d.day != 0; else unknownText">{{ d.day ? ordinalSuffix(d.day) : '* ' }} </span>
          <span *ngIf="imageTypeFilter.uid === 2"><span
              *ngIf="d.quarter != 0; else unknownText">{{ d.quarter ? ordinalSuffix(d.quarter) + ' qtr.' : '*' }}</span></span>
          <ng-template #unknownText><span> ? </span></ng-template>
        </div>
      </div>
    </div>
    
    <!-- TODO: ORDER NUMBER FILTER HERE -->

    <div class="filterDividerLine"></div>

    <div class="filterSection" *ngIf="!civilianMode"
      [ngClass]="{'opened': filterExpandToggles['armyopen'], 'closed': !filterExpandToggles['armyopen']}">
      <!-- Armies Filters -->
      <h6 (click)="collapseAllFilters('armyopen')">
        <span class="selectedCount" [hidden]="!regionalArmies || getSelectedCount(regionalArmies) < 1"> ({{ getSelectedCount(regionalArmies) }} selected)</span>
        Armies
      </h6>
      <div class="innerFilterOptions" [ngClass]="{'mobile': isHandset}">
        <div *ngIf="regionalArmies.length < 30" >
          <label for="armyRadioX" class="form-check-label categoryLabel">
            All Armies
          </label>
          <input type="checkbox" id="armyRadioX" class="checkbox-input" name="armyRadio"
            (ngModelChange)="updateFilter({selected: $event, entity: 'Army', obj: 'All', allSelected: null})"
            [(ngModel)]="allArmies">
        </div>
        <div *ngFor="let army of armies; let i = index" class="parentFilterSegment">
          <!-- (outer) Main Army section filter section -->
          <a class="btn btn-link expander-button me-1" data-bs-toggle="collapse"
          title="Expand this army to reveal its regional armies" (click)="armyExpansions[i] = !armyExpansions[i]"
          [href]="'#army' + i" aria-expanded="false" [attr.aria-controls]="'army' + i">
          <i class="far" [ngClass]="{'fa-minus-circle': armyExpansions[i], 'fa-plus-circle': !armyExpansions[i]}"></i>
        </a>
        <label class="form-check-label categoryLabel" [for]="'armyRadio' + i.toString()" [title]="army.armyName">{{ army.armyName }}</label>
        <input type="checkbox" [id]="'armyRadio' + i" [(ngModel)]="army.selected" name="armyRadio"
          class="checkbox-input"
          (ngModelChange)="updateFilter({selected: $event, entity: 'Army', obj: army, allSelected: null})">
          <div class="collapse" [id]="'army' + i">
            <div *ngFor="let ra of (regionalArmies | armyToRegional : army.uid); let j = index"
              class="">
              <!-- (inner) Regional Armies Filters -->
              <label [for]="'regionalArmyCheck' + i + '-' + j" class="form-check-label" [title]="ra.regionalName">
                {{ ra.regionalName }}
              </label>
              <input type="checkbox" name="regionalArmyCheckboxes" [(ngModel)]="ra.selected"
                [id]="'regionalArmyCheck' + i + '-' + j" class="checkbox-input"
                (ngModelChange)="updateFilter({selected: $event, entity: 'RegionalArmy', obj: ra, allSelected: null})">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="filterSection" *ngIf="!civilianMode"
      [ngClass]="{'opened': filterExpandToggles['unitopen'], 'closed': !filterExpandToggles['unitopen']}">
      <h6 (click)="collapseAllFilters('unitopen'); filterExpandToggles['unitopen'] ? openUnitPicker() : null">
        <span class="selectedCount" [hidden]="!activeUnitFilters || activeUnitFilters.length < 1">
          ({{ activeUnitFilters.length }} selected)
          </span>
        Units
      </h6>
      <div class="innerFilterOptions">
        <button class="btn btn-link" style="padding: 0;" (click)="openUnitPicker()">
          {{ activeUnitFilters.length > 0 ? 'Edit' : 'Select' }} Unit Filters...
        </button>
        <app-unit-filter *ngIf="showUnitPickerFilter" [regiments]="regiments" [states]="locationStates"
          [branches]="branches" [coLetters]="coLetters" [(activeUnitFilters)]="activeUnitFilters"
          (activeUnitFiltersChange)="translateUnitToFilter()" (closePressed)="closeFilterBoxes()"></app-unit-filter>
        <div *ngFor="let u of activeUnitFilters">
          <i class="fal fa-check-square"></i>
          {{ unitArmies[u.army] || '*' }}
          {{ u.corps ? ordinalSuffix(u.corps) : '*' }}
          {{ (u.regiment?.regimentNo) ? ordinalSuffix(u.regiment.regimentNo) : '*' }}
          {{ u.state?.state_Name || '*' }}
          {{ u.branch?.branchName || '*' }}
          {{ u.coLetters?.join(', ') }}
        </div>
      </div>
    </div>

    <div class="filterSection" *ngIf="!civilianMode"
      [ngClass]="{'opened': filterExpandToggles['rankopen'], 'closed': !filterExpandToggles['rankopen']}">
      <h6 (click)="collapseAllFilters('rankopen')">
        <span class="selectedCount" [hidden]="!ranks || getSelectedCount(ranks) < 1"> ({{ getSelectedCount(ranks) }} selected)</span>
        Ranks
      </h6>
      <div class="innerFilterOptions" [ngClass]="{'mobile': isHandset}">
        <div *ngIf="ranks.length < 30">
          <label for="rankCatRadioX" class="form-check-label categoryLabel">
            All Ranks
          </label>
          <input type="checkbox" id="rankCatRadioX" name="rankCatRadio" class="checkbox-input"
            (ngModelChange)="updateFilter({selected: $event, entity: 'RankCats', obj: 'All', allSelected: null})"
            [(ngModel)]="allRanks">
        </div>
        <div *ngFor="let rank of rankCats; let i = index" class="parentFilterSegment">
          <a class="btn btn-link expander-button" data-bs-toggle="collapse"
            title="Expand this rank category to reveal its constituent ranks"
            (click)="rankExpansions[i] = !rankExpansions[i]" [href]="'#rankCat' + i" aria-expanded="false"
            [attr.aria-controls]="'rankCat' + i">
            <i class="far" [ngClass]="{'fa-minus-circle': rankExpansions[i], 'fa-plus-circle': !rankExpansions[i]}"></i>
          </a>
          <label [for]="'rankCatRadio' + i" class="form-check-label categoryLabel" [title]="rank.rankCategory">
            {{ rank.rankCategory }}
          </label>
          <input type="checkbox" [id]="'rankCatRadio' + i" [(ngModel)]="rank.selected" name="rankCatRadio"
            class="checkbox-input"
            (ngModelChange)="updateFilter({selected: $event, entity: 'RankCats', obj: rank, allSelected: null})">
          <div class="collapse" [id]="'rankCat' + i">
            <div *ngFor="let ir of (ranks | rankCatToRank : rank.uid); let j = index">
              <!-- (inner) Rank filters -->
              <label [for]="'innerRankCheck' + i + '-' + j" class="form-check-label" [title]="ir.rankName">
                {{ ir.rankName }}
              </label>
              <input type="checkbox" class="checkbox-input" name="innerRankCheckboxes" [(ngModel)]="ir.selected"
                [id]="'innerRankCheck' + i + '-' + j"
                (ngModelChange)="updateFilter({selected: $event, entity: 'Ranks', obj: ir, allSelected: null})">
            </div>
          </div>
        </div>
      </div>
    </div>

    


    <div class="filterSection" *ngIf="!civilianMode"
      [ngClass]="{'opened': filterExpandToggles['individualopen'], 'closed': !filterExpandToggles['individualopen']}">
      <h6 (click)="collapseAllFilters('individualopen'); filterExpandToggles['individualopen'] ? openIndividualSearch() : null">
        <span class="selectedCount" [hidden]="!this.searchIndividual"> (Search Applied)</span>
        Individual
      </h6>
      <div class="innerFilterOptions">
        <button class="btn btn-link" style="padding: 0;" (click)="openIndividualSearch()">
          Edit Individual Search
        </button>
          <app-individuals-search *ngIf="showIndividualSearch" [typeOfImageId]="imageTypeFilter.uid" [data]="searchIndividual" [rankCats]="rankCats" [regiments]="regiments"
            [states]="locationStates" [branches]="branches" [coLetters]="coLetters" (search)="applyIndividualSearch($event)" (cancel)="closeFilterBoxes()" (clear)="clearIndividualSearch()"></app-individuals-search>
      </div>
    </div>

    
    <div class="filterDividerLine" *ngIf="!civilianMode"></div>

    
    <!-- <app-sidebar-filter [filterTitle]="'Regions'" [showMetaFilter]="true" [optionData]="regionalNames"
      [filterBindingProperty]="'regionalName'" [filterDisplayProperty]="'regionalName'" [openerProp]="'regionalopen'"
      [open]="filterExpandToggles['regionalopen']" (filterChangeEmitter)="updateFilter($event)" (toggleOpen)="collapseAllFilters($event)"></app-sidebar-filter> -->

    <app-sidebar-filter [displayMode]="sidebarFilterTypes.CheckboxMode" [filterTitle]="'States'"
    [showMetaFilter]="true" [parentWidth]="parentWidth$ | async" [optionData]="locationStates" [open]="filterExpandToggles['lsopen']"
    [filterDisplayProperty]="'abbreviation'" [filterBindingProperty]="'uid'" [openerProp]="'lsopen'"
    (filterChangeEmitter)="updateFilter($event)" (toggleOpen)="collapseAllFilters($event)"></app-sidebar-filter>

    <app-sidebar-filter [filterTitle]="'Locations'" [showMetaFilter]="true" [optionData]="locations"
    [filterBindingProperty]="'location'" [filterDisplayProperty]="'location'" [openerProp]="'locationopen'" [parentWidth]="parentWidth$ | async"
    [open]="filterExpandToggles['locationopen']" (filterChangeEmitter)="updateFilter($event)" (toggleOpen)="collapseAllFilters($event)"></app-sidebar-filter>

    <app-sidebar-filter *ngIf="!civilianMode" [filterTitle]="'Battles'" [showMetaFilter]="true" [optionData]="battles" [parentWidth]="parentWidth$ | async"
    [filterBindingProperty]="'uid'" [filterDisplayProperty]="'name'" [openerProp]="'battleopen'" [open]="filterExpandToggles['battleopen']"
    (filterChangeEmitter)="updateFilter($event)" (toggleOpen)="collapseAllFilters($event)"></app-sidebar-filter>

    <div class="filterDividerLine"></div>

    <app-sidebar-filter [filterTitle]="'Portrait/Field'" *ngIf="imageTypeFilter.typeOfImage == 'Photos' || (imageTypeFilter.uid === 0 && !galleryTypeSvc.prePrintedMode)"
      [optionData]="PFRadio"
      [filterDisplayProperty]="'disp'"
      [filterBindingProperty]="'val'" 
      [open]="filterExpandToggles['pfopen']"
      [openerProp]="'pfopen'"
      [displayMode]="sidebarFilterTypes.RadioButtonMode"
      (filterChangeEmitter)="updateFilter($event)"
      (toggleOpen)="collapseAllFilters($event)">
    </app-sidebar-filter>

    <app-sidebar-filter [filterTitle]="'Mounted'" *ngIf="imageTypeFilter.typeOfImage == 'Photos' || (imageTypeFilter.uid === 0 && !galleryTypeSvc.prePrintedMode)" 
      [optionData]="mountedFilter"
      [filterDisplayProperty]="'disp'"
      [filterBindingProperty]="'val'" 
      [open]="filterExpandToggles['mountedopen']" 
      [openerProp]="'mountedopen'"
      [displayMode]="sidebarFilterTypes.RadioButtonMode"
      (filterChangeEmitter)="updateFilter($event)" (toggleOpen)="collapseAllFilters($event)">
    </app-sidebar-filter>

    <div class="filterSection" *ngIf="!civilianMode"
      [ngClass]="{'opened': filterExpandToggles['weaponopen'], 'closed': !filterExpandToggles['weaponopen']}">
      <h6 (click)="collapseAllFilters('weaponopen')">
        <span class="selectedCount" [hidden]="!weapons || getSelectedCount(weapons) < 1"> ({{ getSelectedCount(weapons) }} selected)</span>
        Weapons
      </h6>
      <div class="innerFilterOptions" [ngClass]="{'mobile': isHandset}">
        <div *ngIf="weapons.length < 30">
          <label for="weaponCatRadioX" class="form-check-label categoryLabel">
            Any Weapons
          </label>
          <input type="checkbox" id="weaponCatRadioX" name="weaponCatRadio" class="checkbox-input"
            (ngModelChange)="updateFilter({selected: $event, entity: 'WeaponCats', obj: 'All', allSelected: null})"
            [(ngModel)]="allWeapons">
        </div>
        <div *ngFor="let weapon of weaponCats; let i = index" class="parentFilterSegment">
          <a class="btn btn-link expander-button" data-bs-toggle="collapse"
            title="Expand this weapon category to reveal specific weapons"
            (click)="weaponExpansions[i] = !weaponExpansions[i]" [href]="'#weaponCat' + i"
            aria-expanded="false" [attr.aria-controls]="'weaponCat' + i">
            <i class="far"
              [ngClass]="{'fa-minus-circle': weaponExpansions[i], 'fa-plus-circle': !weaponExpansions[i]}"></i>
          </a>
          <label [for]="'weaponCatRadio' + i" class="form-check-label categoryLabel" [title]="weapon.weapon_Category">
            {{ weapon.weapon_Category }}
          </label>
          <input type="checkbox" [id]="'weaponCatRadio' + i" [(ngModel)]="weapon.selected" name="weaponCatRadio"
            class="checkbox-input"
            (ngModelChange)="updateFilter({selected: $event, entity: 'WeaponCats', obj: weapon, allSelected: null})">
          <div class="collapse" [id]="'weaponCat' + i">
            <div *ngFor="let sw of (weapons | weaponCatToWeapon : weapon.uid); let j = index" style="padding-left: 12px;">
              <!-- (inner) Weapon filters -->
              <label [for]="'innerWeaponCheck' + i + '-' + j" class="form-check-label" [title]="sw.weapon">
                {{ sw.weapon }}
              </label>
              <input type="checkbox" class="checkbox-input" name="innerWeaponCheckboxes" [(ngModel)]="sw.selected"
                [id]="'innerWeaponCheck' + i + '-' + j"
                (ngModelChange)="updateFilter({selected: $event, entity: 'Weapons', obj: sw, allSelected: null})">
            </div>
          </div>
        </div>
      </div>
    </div>


    <app-sidebar-filter *ngIf="isAdmin" [filterTitle]="'Checked Out'" [optionData]="checkedOutFilter"
      [open]="filterExpandToggles['checkedoutopen']" [includeAllOption]=false [filterBindingProperty]="'val'"
      [filterDisplayProperty]="'disp'" [displayMode]="sidebarFilterTypes.RadioButtonMode" [openerProp]="'checkedoutopen'"
      (filterChangeEmitter)="updateFilter($event)" (toggleOpen)="collapseAllFilters($event)"></app-sidebar-filter>

    <app-sidebar-filter *ngIf="isAdmin" [filterTitle]="'Fully Tagged'" [optionData]="fullyTaggedFilter"
      [open]="filterExpandToggles['fullytaggedopen']" [includeAllOption]=false [filterBindingProperty]="'val'"
      [filterDisplayProperty]="'disp'" [displayMode]="sidebarFilterTypes.RadioButtonMode" [openerProp]="'fullytaggedopen'"
      (filterChangeEmitter)="updateFilter($event)" (toggleOpen)="collapseAllFilters($event)"></app-sidebar-filter>

    <app-sidebar-filter *ngIf="imageTypeFilter.uid !== 0 && isAdmin && !isHandset; else segmentedUploadBatchFilter"
      [filterTitle]="'Upload Batches'" [optionData]="batchLogs" [filterDisplayProperty]="'toReadable'"
      [filterBindingProperty]="'batchNo'" [displayPropertyIsFunc]=true [displayMode]="sidebarFilterTypes.CheckboxMode" [parentWidth]="parentWidth$ | async"
      [showMetaFilter]="true" [open]="filterExpandToggles['batchopen']" [openerProp]="'batchopen'"
      (filterChangeEmitter)="updateFilter($event)" (toggleOpen)="collapseAllFilters($event)"></app-sidebar-filter>

    <ng-template #segmentedUploadBatchFilter>
      <div *ngIf="isAdmin && !isHandset" class="filterSection"
        [ngClass]="{'opened': filterExpandToggles['batchopen'], 'closed': !filterExpandToggles['batchopen']}">
        <h6 (click)="collapseAllFilters('batchopen')">
          <span class="selectedCount" [hidden]="!batchLogs || getSelectedCount(batchLogs) < 1"> ({{ getSelectedCount(batchLogs) }} selected)</span>
          Upload Batches
        </h6>
        <div class="innerFilterOptions">
          <div *ngIf="batchLogs.length < 30">
            <label for="batchTypeRadioX" class="form-check-label categoryLabel">
              All Upload Batches
            </label>
            <input type="checkbox" id="batchTypeRadioX" name="batchTypeRadio" class="checkbox-input"
              (ngModelChange)="updateFilter({selected: $event, entity: 'Image Types', obj: 'All', allSelected: null})"
              [(ngModel)]="allBatches">
          </div>
          <div *ngFor="let t of imageTypes; let i = index" class=" parentFilterSegment">
            <a class="btn btn-link expander-button" data-bs-toggle="collapse"
              title="Expand this image type to reveal related upload batches"
              (click)="batchExpansions[i] = !batchExpansions[i]" [href]="'#batchType' + i"
              aria-expanded="false" [attr.aria-controls]="'batchType' + i">
              <i class="far"
                [ngClass]="{'fa-minus-circle': batchExpansions[i], 'fa-plus-circle': !batchExpansions[i]}"></i>
            </a>
            <label [for]="'batchTypeRadio' + i" class="form-check-label categoryLabel">
              {{ t.txt }}
            </label>
            <input type="checkbox" class="checkbox-input" [id]="'batchTypeRadio' + i" [(ngModel)]="t.selected"
              name="batchTypeRadio"
              (ngModelChange)="updateFilter({selected: $event, entity: 'Image Types', obj: t, allSelected: null})">
            <div class="collapse" [id]="'batchType' + i">
              <cdk-virtual-scroll-viewport class="scroller" itemSize="22">
                <div *cdkVirtualFor="let batch of (batchLogs | imageTypeToBatch: t.val); let j = index; templateCacheSize: 1" style="padding-left: 12px;">
                  <!-- (inner) Image type for upload log filters -->
                  <label [for]="'innerBatchCheck' + i + '-' + j" class="form-check-label">
                    {{ batch }}
                  </label>
                  <input type="checkbox" class="checkbox-input" name="innerBatchCheckboxes"
                    [(ngModel)]="batch.selected" [id]="'innerBatchCheck' + i + '-' + j"
                    (ngModelChange)="updateFilter({selected: $event, entity: 'Upload Batches', obj: batch, allSelected: null})">
                </div>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="filterSection"
      [ngClass]="{'opened': filterExpandToggles['sourcecallnoopen'], 'closed': !filterExpandToggles['sourcecallnoopen']}">
      <h6 (click)="collapseAllFilters('sourcecallnoopen'); filterExpandToggles['sourcecallnoopen'] ? openSourceCallNoFilter() : null" style="margin-left: -5px;">
        <span class="selectedCount" [hidden]="(!activeSourceCallNoFilters || !activeSourceCallNoFilters.length) && !activeSourceCallNoFilter?.lU_Source">(in use) </span>Source/Call Numbers
      </h6>
      <div class="innerFilterOptions">
        <button class="btn btn-link" style="padding: 0;" (click)="openSourceCallNoFilter()">
          Select Source / Call # Filter...
        </button>
        <app-source-call-no-box #sourceCallNoBox *ngIf="showSourceCallNoFilter"
          [activeFilter]="activeSourceCallNoFilter" [activeFilters]="activeSourceCallNoFilters" [luSources]="luSources" [callNumberData]="filteredCallNumberData"
          (levelOfSpecificity)="changeLevelOfSpec($event)" (filterSet)="setSourceCallNoFilter($event)"
          (sourceChanged)="filterCallNumbersBySource($event)" (callNumberChanged)="setCallNoFilter($event)" (closePressed)="closeFilterBoxes();" (clearPressed)="filterCallNumbersBySource(undefined)">
        </app-source-call-no-box>
        <br>
        <div class="me-1" *ngIf="this.activeSourceCallNoFilters.length">
          <strong>{{ this.activeSourceCallNoFilter?.lU_Source?.source }}</strong>
          <br>
          <span>
            {{ this.activeSourceCallNoFilter?.callNumberL1 }}<br>
            <span
              *ngIf="this.activeSourceCallNoFilter?.callNumberL2 ">{{ ':' + this.activeSourceCallNoFilter?.callNumberL2 }}<br></span>
            <span
              *ngIf="this.activeSourceCallNoFilter?.callNumberL3">{{ ':' + this.activeSourceCallNoFilter?.callNumberL3 }}<br></span>
            <span
              *ngIf="this.activeSourceCallNoFilter?.callNumberL4">{{ ':' + this.activeSourceCallNoFilter?.callNumberL4 }}<br></span>
            <!--<span *ngIf="!this.activeSourceCallNoFilter?.callNumberL4">: *</span>-->
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="isHandset" class="filterSection resetFiltersMobile mobile row align-items-center justify-content-center">
      <div class="filtersApplied mobile ms-2 me-2">
        <i class="fal fa-filter"></i> Filters applied: {{ sumOfFiltersApplied() }}
      </div>
      <div style="width: auto;">
        <app-slant-button [outlineMode]="sumOfFiltersApplied() < 1" [btnColor]="sumOfFiltersApplied() > 0 ? 'bw' : 'gray'" [disabled]="sumOfFiltersApplied() < 1" (click)="resetFilters(true, undefined, true)" tooltip="Reset filters and search" btnIconClass="fas fa-filter fa-inverse">Reset Filters &nbsp;</app-slant-button>
      </div>
    </div>

  </div>
  &nbsp;
</div>
<div *ngIf="!isHandset" class="resetFiltersContainer row align-items-center justify-content-center" >
  <!-- [ngClass]="{'mobile': isHandset} -->
  <div class="filtersApplied ms-2 me-2">
    <i class="fal fa-filter"></i> Filters applied: {{ sumOfFiltersApplied() }}
  </div>
  <app-slant-button [outlineMode]="sumOfFiltersApplied() < 1" [btnColor]="sumOfFiltersApplied() > 0 ? 'bw' : 'gray'" [disabled]="sumOfFiltersApplied() < 1" (click)="resetFilters(true, undefined, true)" tooltip="Reset filters and search" btnIconClass="fas fa-filter fa-inverse">Reset Filters &nbsp;</app-slant-button>
</div>
